import src from "IMAGE";
export default { src, width: 1920, height: 515, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAL0lEQVR42jWJAQoAQAjC+v93C4pQPDxIEMYWmanu1u6K5L/Zzi2qSjMjALqZ7dweEHg+oVYAqaQAAAAASUVORK5CYII="};
